export default "__VITE_ASSET__DPmXcovC__"